import { render, staticRenderFns } from "./Orderedit.vue?vue&type=template&id=1d28c1a2&scoped=true"
import script from "./Orderedit.vue?vue&type=script&lang=js"
export * from "./Orderedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28c1a2",
  null
  
)

export default component.exports